<div class="container">
  <div class="container__middle empty-setup" *ngIf="!automation.triggers?.length; else setupComplete">
    <button mat-flat-button (click)="open.emit()"><mat-icon>settings</mat-icon>&nbsp;Setup the Trigger</button>
  </div>
  <ng-template #setupComplete>
    <div class="container__top">
      <span><mat-icon svgIcon="heroicons_outline:adjustments"></mat-icon>&nbsp;Triggers</span>
      <mat-icon #origin (click)="overlayHelper.open()" class="container__top__setup-button"
        >keyboard_arrow_down</mat-icon
      >
      <app-overlay-helper class="display-none" #overlayHelper [overlayOrigin]="origin" [position]="position">
        <div class="options-panel">
          <p>Options</p>
          <p (click)="openSetup()"><mat-icon>edit</mat-icon>&nbsp;Edit</p>
        </div>
      </app-overlay-helper>
    </div>
    <div class="container__middle">
      <ul>
        <li *ngFor="let trigger of automation.triggers">
          <ng-container *ngIf="!(trigger.attr && trigger.value && trigger.type)">
            <button mat-flat-button (click)="open.emit()"><mat-icon>settings</mat-icon>&nbsp;Setup the Trigger</button>
          </ng-container>
          <ng-container *ngIf="trigger.type === TriggerType.ObjectCreated">
            When a new <strong>{{ trigger.value | relatedToTypeTitle: [] }}</strong> is created
          </ng-container>
          <ng-container *ngIf="trigger.type === TriggerType.AttributeChange">
            When <strong>{{ trigger.attr | fieldNameToLabel: automation.target_model }}</strong> changes to
            <strong>{{ trigger.value | readableField: {}:getField(trigger.attr):formData.options }}</strong
            >.
          </ng-container>
        </li>
      </ul>
    </div>
  </ng-template>
</div>
